import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

const redistributionRoutes = [
	{
		component: LazyComponent(lazy(() => import('./List'))),
		path: '/redistribution/',
	},
];

export default redistributionRoutes;
